import { SeriesTypeEnum } from "../interface/type";

import { BaseWordCloudSeries } from "./base";

import { Factory } from "../../core/factory";

import { registerWordCloudAnimation } from "./animation";

import { wordcloudTransform, wordcloudShapeTransform } from "@visactor/vlayouts";

import { registerTextMark } from "../../mark/text";

export class WordCloudSeries extends BaseWordCloudSeries {
    constructor() {
        super(...arguments), this.type = SeriesTypeEnum.wordCloud;
    }
}

WordCloudSeries.type = SeriesTypeEnum.wordCloud;

export const registerWordCloudSeries = () => {
    Factory.registerGrammarTransform("wordcloud", {
        transform: wordcloudTransform
    }), registerTextMark(), registerWordCloudAnimation(), Factory.registerSeries(WordCloudSeries.type, WordCloudSeries);
};

export const registerWordCloudShapeSeries = () => {
    Factory.registerGrammarTransform("wordcloudShape", {
        transform: wordcloudShapeTransform
    }), Factory.registerGrammarTransform("wordcloud", {
        transform: wordcloudTransform
    }), registerTextMark(), registerWordCloudAnimation(), Factory.registerSeries(WordCloudSeries.type, WordCloudSeries);
};
//# sourceMappingURL=word-cloud.js.map
